import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/future",
    name: "future",
    component: () =>
      import("../views/FutureInvest.vue"),
  },
  {
    path: "/products",
    name: "products",
    component: () =>
      import("../views/Products.vue"),
  },
  {
    path: "/service",
    name: "service",
    component: () =>
      import("../views/Service.vue"),
  },
  {
    path: "/platform",
    name: "platform",
    component: () =>
      import("../views/Platform.vue"),
  },
  {
    path: "/deleteAccount",
    name: "deleteAccount",
    component: () =>
      import("../views/DeleteAccount.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import("../views/pages/Privacy.vue"),
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () =>
      import("../views/pages/Agreement.vue"),
  },
  /* {
    path: "/privacy_cn",
    name: "privacy_cn",
    component: () =>
      import("../views/pages/Privacy_cn.vue"),
  },
  {
    path: "/agreement_cn",
    name: "agreement_cn",
    component: () =>
      import("../views/pages/Agreement_cn.vue"),
  }, */
];
const  scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  }
  return { left: 0, top:0 };
}
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior
});

export default router;
